module.exports = __webpack_public_path__ + "static/The_Dream_-_IV_Play_[Music_Video]-f5c289d4a4688d7e92896be290e6c122.mp4";